import * as React from 'react'
import { Helmet } from 'react-helmet-async'
import { useTranslation } from 'react-i18next'
import type { PerformanceItemsResponse } from '../../interfaces'
import PerformanceHomeLayout from '../../layouts/Performance/PerformanceHomeLayout'

const PerformanceHome = (): React.ReactElement => {
  const { t } = useTranslation()

  return (
    <React.Fragment>
      <Helmet>
        <title>{t('performance_center', 'Performance Center')}</title>
        <meta name="description" content="Performance Center page" />
      </Helmet>

      <PerformanceHomeLayout />
    </React.Fragment>
  )
}

export default PerformanceHome
